import Pagination from './Pagination';
import formatDateTimeUK from '@/helpers/formatDateTimeUK';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Paper from '@mui/material/Paper';
import { Box } from '@mui/material';
import TablePagination from '@mui/material/TablePagination';

import { getRequest } from '@/services/api';

import { useEffect, useState } from 'react';

const InsurerTestRequests = ({ user }) => {
	const [insurerTestRequestData, setInsurerTestRequestData] = useState(null);
	// const [orderDirection, setOrderDirection] = useState('asc');

	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(5);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	useEffect(() => {
		const fetchInsurerTests = async () => {
			try {
				const fetchedTests = await getRequest(
					`/products/insurer-test-requests/${user.customer_id}`
				);
				setInsurerTestRequestData(fetchedTests.data);
			} catch (error) {
				console.error('Error fetching insurer tests:', error);
			}
		};
		fetchInsurerTests();
	}, []);

	// const handleSortByDate = () => {
	//     setOrderDirection((prev) => (prev === 'asc' ? 'desc' : 'asc'));
	// };

	// const sortByDate = (rows) => {
	//     if (!Array.isArray(rows)) return [];
	//     return [...rows].sort((a, b) => {
	//         const dateA = new Date(a.created_at);
	//         const dateB = new Date(b.created_at);
	//         return orderDirection === 'asc' ? dateA - dateB : dateB - dateA;
	//     });
	// };

	if (!insurerTestRequestData) {
		return (
			<Box sx={{ width: '100%' }}>
				<h2>Insured Test Requests</h2>
				<p>No available insured customer test requests</p>
			</Box>
		);
	}

	const renderPage = () => {
		return (
			<Box sx={{ width: '100%' }}>
				<Paper sx={{ width: '100%', mb: 2 }}>
					<TableContainer style={{ overflowX: 'auto', width: '100%' }}>
						<Table className="table table-hover table-center mb-0" aria-label="simple table">
							<TableHead>
								<TableRow>
									<TableCell sx={{ width: 40, padding: '0.25rem' }}>#</TableCell>
									{/* <TableCell align="right">Insured Request ID</TableCell> */}
									<TableCell sx={{ width: 100, whiteSpace: 'nowrap' }}>Insurer</TableCell>
									<TableCell sx={{ width: 100 }}>Pre-Auth Code</TableCell>
									<TableCell sx={{ width: 100 }}>Insurance Policy Number</TableCell>
									<TableCell sx={{ width: 150 }}>First Name</TableCell>
									<TableCell sx={{ width: 150 }}>Last Name</TableCell>
									<TableCell sx={{ width: 150 }}>Date of Birth</TableCell>

									<TableCell sx={{ width: 220, overflow: 'hidden', textOverflow: 'ellipsis' }}>
										Email
									</TableCell>
									<TableCell sx={{ width: 200 }}>Phone Number</TableCell>
									<TableCell sx={{ width: 200 }}>Home Address</TableCell>
									<TableCell sx={{ width: 200 }}>Referring Clinician</TableCell>
									<TableCell sx={{ width: 200 }}>Referring Clinician Contact</TableCell>
									<TableCell sx={{ width: 200 }}>Referring Clinician Email</TableCell>
									{/* <TableCell sortDirection={orderDirection}>
                                    <TableSortLabel
                                        active={true}
                                        direction={orderDirection}
                                        onClick={handleSortByDate}
                                    >
                                        Preferred date
                                    </TableSortLabel>
                                </TableCell> */}
									<TableCell sx={{ width: 200 }}>Preferred Date</TableCell>
									<TableCell sx={{ width: 200 }}>Preferred Time</TableCell>
									<TableCell sx={{ width: 200 }}>Test Request</TableCell>
									<TableCell sx={{ width: 200 }}>Blood Test Location</TableCell>
									<TableCell sx={{ width: 200 }}>Comments</TableCell>
									<TableCell sx={{ width: 200 }}>For Whom</TableCell>
									<TableCell sx={{ width: 200 }}>Relationship</TableCell>
									<TableCell sx={{ width: 200 }}>Key Symptoms</TableCell>
									<TableCell sx={{ width: 200 }}>Created On</TableCell>
								</TableRow>
							</TableHead>

							<TableBody>
								{insurerTestRequestData
									?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
									.map((request, index) => (
										<TableRow key={request.insured_request_id}>
											<TableCell>{index + 1}</TableCell>
											{/* <TableCell>{request.insured_request_id}</TableCell> */}
											<TableCell>{request.insurer}</TableCell>
											<TableCell>{request.pre_auth_code}</TableCell>
											<TableCell>{request.insurance_policy_number}</TableCell>
											<TableCell>{request.first_name}</TableCell>
											<TableCell>{request.last_name}</TableCell>
											<TableCell>{formatDateTimeUK(request.date_of_birth)}</TableCell>
											<TableCell>{request.email}</TableCell>
											<TableCell>{request.phone_number}</TableCell>
											<TableCell>{request.home_address}</TableCell>
											<TableCell>{request.referring_clinician}</TableCell>
											<TableCell>{request.referring_clinician_contact}</TableCell>
											<TableCell>{request.referring_clinician_email}</TableCell>
											<TableCell>{formatDateTimeUK(request.preferred_date)}</TableCell>
											<TableCell>{request.preferred_time}</TableCell>
											<TableCell>{request.test_request}</TableCell>
											<TableCell>{request.blood_test_location}</TableCell>
											<TableCell>{request.comments}</TableCell>
											<TableCell>{request.for_whom}</TableCell>
											<TableCell>{request.relationship}</TableCell>
											<TableCell>{request.key_symptoms}</TableCell>
											<TableCell>{formatDateTimeUK(request.created_at)}</TableCell>
										</TableRow>
									))}
							</TableBody>
						</Table>
					</TableContainer>
					<TablePagination
						rowsPerPageOptions={[5, 10, 25]}
						component="div"
						count={insurerTestRequestData?.length}
						rowsPerPage={rowsPerPage}
						page={page}
						onPageChange={handleChangePage}
						onRowsPerPageChange={handleChangeRowsPerPage}
					/>
				</Paper>
			</Box>
		);
	};

	return (
		<div className="">
			<h2>Insured Test Requests</h2>
			<div className="">
				<div className="card-body">
					{/* <Pagination
                        data={insurerTestRequestData}
                        renderPage={renderPage}
                    /> */}
					{renderPage()}
				</div>
			</div>
		</div>
	);
};

export default InsurerTestRequests;
